// Shared rule for deciding whether a typhoon is close enough to Miyakojima to
// mention it (Threads/Instagram daily post, Ocean Guide top alert, forecast
// panel and typhoon-affected day logic). A distant system, such as one near
// the Ogasawara Islands (~1,300-1,700 km away), must not be shown as
// "affecting Miyakojima" or blamed for ordinary monsoon waves.
export const TYPHOON_MAX_CENTER_KM = 800;
export const TYPHOON_MAX_EFFECTIVE_KM = 300;

// centerKm: distance from Miyakojima to the forecast center.
// uncertaintyKm: radius of the JMA probability circle (70% circle), if any.
export const isTyphoonPointNearMiyako = (centerKm, uncertaintyKm = 0) => {
  if (!Number.isFinite(centerKm)) return false;
  const radius = Number.isFinite(uncertaintyKm) ? uncertaintyKm : 0;
  return centerKm <= TYPHOON_MAX_CENTER_KM
    && Math.max(0, centerKm - radius) <= TYPHOON_MAX_EFFECTIVE_KM;
};
